module.exports = __webpack_public_path__ + "img/card-4.aae6ffbf.jpg";